(function () {
  const UID = 'geo3d-main';

  let LAST_GPX = null;

    window.__geo3dPreviewSeeded = window.__geo3dPreviewSeeded || {};

  function seedGeo3DPreviewInBackground(payload) {
    if (!payload || !payload.geo3d_config_id || !payload.bounds) return;

    const id = payload.geo3d_config_id;

    if (window.__geo3dPreviewSeeded[id]) return;

    window.__geo3dPreviewSeeded[id] = true;

    fetch('https://geo3d.skylinecity.store/api/preview', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        if (!res.ok) {
          throw new Error('Preview seed HTTP ' + res.status);
        }

        return res.json().catch(function () {
          return null;
        });
      })
      .then(function (data) {
        console.log('[Geo3D] preview seed enviado:', id, data);
      })
      .catch(function (err) {
        console.warn('[Geo3D] preview seed failed:', id, err);
        delete window.__geo3dPreviewSeeded[id];
      });
  }

  window.seedGeo3DPreviewInBackground = seedGeo3DPreviewInBackground;

  function makeGeo3DId() {
  if (window.crypto && crypto.randomUUID) {
    return 'g3d_' + crypto.randomUUID();
  }

  return 'g3d_' + Date.now() + '_' + Math.random().toString(16).slice(2);
}

function buildConfigFingerprint(payload) {
  if (!payload) return '';

  const b = payload.bounds || {};

  const parts = [
    payload.mode || '',
    payload.productType || '',
    payload.sizeMm || '',
    payload.baseMm || '',
    payload.sizeLabel || '',
    payload.frameStyle || '',
    payload.meshColor || '',
    payload.trackColor || '',
    payload.exaggeration || '',
    b.north ? Number(b.north).toFixed(6) : '',
    b.south ? Number(b.south).toFixed(6) : '',
    b.east ? Number(b.east).toFixed(6) : '',
    b.west ? Number(b.west).toFixed(6) : '',
    payload.gpx && payload.gpx.name ? payload.gpx.name : '',
    payload.gpx && payload.gpx.points ? payload.gpx.points.length : ''
  ];

  return parts.join('|');
}

function ensureHidden(form, id, name, defaultValue) {
  if (!form) return null;

  let input = form.querySelector('#' + id);

  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.id = id;
    input.value = defaultValue || '';
    form.appendChild(input);
  }

  input.type = 'hidden';
  input.id = id;
  input.name = name;

  if (!input.value && defaultValue) {
    input.value = defaultValue;
  }

  return input;
}

function buildGeo3DLabel(payload) {
  if (!payload) return 'Relief Map personalizado';

  if (payload.placeName) return payload.placeName;
  if (payload.name) return payload.name;
  if (payload.label && !/^Relief Map /.test(payload.label)) return payload.label;

  const b = payload.bounds;

  if (
    b &&
    typeof b.north !== 'undefined' &&
    typeof b.south !== 'undefined' &&
    typeof b.east !== 'undefined' &&
    typeof b.west !== 'undefined'
  ) {
    const lat = ((Number(b.north) + Number(b.south)) / 2).toFixed(5);
    const lng = ((Number(b.east) + Number(b.west)) / 2).toFixed(5);
    return 'Relief Map ' + lat + ', ' + lng;
  }

  return 'Relief Map personalizado';
}

function ensureGeo3DExtraInputsInRealProductForm() {
  const form = getRealProductForm();
  if (!form) return null;

  return {
    configInput: ensureHidden(form, 'Geo3DConfigId', 'properties[_geo3d_config_id]', ''),
    labelInput: ensureHidden(form, 'Geo3DLabel', 'properties[Relief map]', ''),
    previewLinkInput: ensureHidden(form, 'Geo3DPreviewLink', 'properties[Preview]', ''),
    previewStatusInput: ensureHidden(form, 'Geo3DPreviewStatus', 'properties[_geo3d_preview_status]', 'pending'),
    previewUrlInput: ensureHidden(form, 'Geo3DPreviewUrl', 'properties[_geo3d_preview_url]', '')
  };
}

function getOrCreateGeo3DConfigId(inputs, payload) {
  if (!inputs || !inputs.configInput) return '';

  const fingerprint = buildConfigFingerprint(payload);

  window.__geo3dLastFingerprint = window.__geo3dLastFingerprint || '';

  const mustCreateNew =
    !inputs.configInput.value ||
    !window.__geo3dLastFingerprint ||
    window.__geo3dLastFingerprint !== fingerprint;

  if (mustCreateNew) {
    inputs.configInput.value = makeGeo3DId();
    window.__geo3dLastFingerprint = fingerprint;
  }

  return inputs.configInput.value;
}

function buildGeo3DPreviewUrl(configId) {
  if (!configId) return '';
  return 'https://geo3d.skylinecity.store/previews/' + configId + '.jpg';
}

  function killGhostGeo3DJson() {
    const all = document.querySelectorAll('#Geo3DJson');
    if (all.length <= 1) return;

    const real =
      document.querySelector('product-form form #Geo3DJson') ||
      document.querySelector('form[action*="/cart/add"] #Geo3DJson');

    all.forEach((el) => {
      const isGhost = !el.closest('product-form form') && el.getAttribute('form');
      if (isGhost) el.remove();
      if (real && el !== real && el.id === 'Geo3DJson') el.remove();
    });
  }

  function numOr(value, fallback) {
    const n = Number(value);
    return Number.isFinite(n) ? n : fallback;
  }

  function getRealProductForm() {
    return (
      document.querySelector('product-form form[action*="/cart/add"]') ||
      document.querySelector('product-form form') ||
      document.querySelector('form[action*="/cart/add"]')
    );
  }

  function ensureHiddenInRealProductForm() {
    const form = getRealProductForm();
    if (!form) return null;

    // Si existe el input legacy público, lo renombramos al privado
    let legacy = form.querySelector('[name="properties[geo3d_json]"]');
    let input = form.querySelector('[name="properties[_geo3d_json]"]') || form.querySelector('#Geo3DJson');

    if (legacy && !input) {
      input = legacy;
    } else if (legacy && input && legacy !== input) {
      legacy.remove();
    }

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.id = 'Geo3DJson';
      input.value = '';
      form.appendChild(input);
    }

    input.type = 'hidden';
    input.id = 'Geo3DJson';
    input.name = 'properties[_geo3d_json]';

    return input;
  }

  function getExistingHiddenPayload() {
    const input =
      document.querySelector('product-form form [name="properties[_geo3d_json]"]') ||
      document.querySelector('form[action*="/cart/add"] [name="properties[_geo3d_json]"]') ||
      document.querySelector('#Geo3DJson');

    if (!input || !input.value) return null;

    try {
      return JSON.parse(input.value);
    } catch (e) {
      return null;
    }
  }

  function getBestRawPayload() {
    const s = window.__geo3dState || {};
    const fromState = s[UID] || null;

    // Si el embed ya dejó un hidden completo, lo usamos como respaldo/merge.
    const fromHidden = getExistingHiddenPayload();

    // Prioridad:
    // 1. Estado global si existe.
    // 2. Hidden actual si existe.
    // 3. null.
    if (fromState && typeof fromState === 'object') {
      return {
        ...(fromHidden || {}),
        ...fromState
      };
    }

    return fromHidden || null;
  }

  function buildFinalPayload(p) {
    if (!p) return null;

    const kmValue = typeof p.km !== 'undefined' ? Number(p.km) : 0;

    // IMPORTANTE:
    // Antes este archivo reconstruía un payload legacy desde cero.
    // Ahora partimos del payload completo para conservar:
    // mode, productType, terrainProvider, waterMode, roads, buildings, previewScene, etc.
    const payload = {
      ...p,

      uid: p.uid || UID,
      bounds: p.bounds || null,
      zoom: typeof p.zoom !== 'undefined' ? p.zoom : null,
      km: Number.isFinite(kmValue) ? kmValue : 0,
      exaggeration: typeof p.exaggeration !== 'undefined' ? Number(p.exaggeration) : 1,
      meshColor: p.meshColor || null,
      trackColor: p.trackColor || null,

      // Valores finales para producción/pedido.
      // Forzamos grid alto para STL final, pero conservamos el resto del contrato.
      tileZoom: typeof p.tileZoom !== 'undefined' && p.tileZoom !== null ? Number(p.tileZoom) : 14,
      grid: 1024,
      sizeMm: typeof p.sizeMm !== 'undefined' && p.sizeMm !== null ? Number(p.sizeMm) : 114,
      baseMm: typeof p.baseMm !== 'undefined' && p.baseMm !== null ? Number(p.baseMm) : 6,
      zMmPerM: typeof p.zMmPerM !== 'undefined' && p.zMmPerM !== null ? Number(p.zMmPerM) : 0.03,
      zMode: p.zMode || 'scale_true',
      flipX: typeof p.flipX !== 'undefined' ? !!p.flipX : false,
      flipY: typeof p.flipY !== 'undefined' ? !!p.flipY : false,
      sizeLabel: p.sizeLabel || null
    };

    payload.kmMode = payload.km === 0 ? 'gpx' : 'radius';

    const gpx = p.gpx || LAST_GPX || null;

    if (gpx && Array.isArray(gpx.points) && gpx.points.length) {
      const MAX = 1500;
      let pts = gpx.points;

      if (pts.length > MAX) {
        const step = Math.ceil(pts.length / MAX);
        pts = pts.filter((_, i) => i % step === 0);
      }

      payload.gpx = {
        name: gpx.name || 'route.gpx',
        points: pts
      };
    } else {
      payload.gpx = null;
    }

    // Defensa para modo ciudad.
    // Si el payload viene como city/cityscape, garantizamos que no se pierdan
    // edificios, carreteras ni agua en el pedido.
    if (payload.mode === 'city' || payload.productType === 'cityscape') {
      payload.mode = 'city';
      payload.productType = 'cityscape';

      payload.terrainProviderRequested = payload.terrainProviderRequested || 'mapterhorn';
      payload.terrainProviderFallback = payload.terrainProviderFallback || 'europe_dem10';
      payload.terrainProviderForOrder = payload.terrainProviderForOrder || 'europe_dem10';

      // Conservamos terrainProvider si ya viene resuelto.
      payload.terrainProvider = payload.terrainProvider || payload.terrainProviderForOrder || 'europe_dem10';

      payload.waterMode = payload.waterMode || 'terrain_recess';
      payload.waterSource = payload.waterSource || 'osmdata_water_polygons';
      payload.waterLoweringMm =
        typeof payload.waterLoweringMm !== 'undefined' && payload.waterLoweringMm !== null
          ? Number(payload.waterLoweringMm)
          : 1;

      payload.roads = {
        ...(payload.roads || {}),
        enabled: true,
        source: payload.roads?.source || 'osm_overpass',
        mode: payload.roads?.mode || 'terrain_overlay',
        final: {
          generateInBackend: true,
          usePreviewGeometry: false,
          ...(payload.roads?.final || {})
        }
      };

      payload.buildings = {
        ...(payload.buildings || {}),
        enabled: true,
        final: {
          generateInBackend: true,
          usePreviewGeometry: false,
          ...(payload.buildings?.final || {})
        }
      };

      payload.previewScene = {
        ...(payload.previewScene || {}),
        enabled: !!payload.previewScene?.enabled,
        source: payload.previewScene?.source || 'preview-scene',
        url: payload.previewScene?.url || null
      };
    }

    // Defensa para modo relieve/montaña.
    // Si no es city, no forzamos edificios ni carreteras.
    if (payload.mode !== 'city' && payload.productType !== 'cityscape') {
      payload.mode = payload.mode || 'relief';
      payload.productType = payload.productType || 'relief';
      payload.terrainProviderRequested = payload.terrainProviderRequested || 'copernicus';
      payload.terrainProvider = payload.terrainProvider || payload.terrainProviderRequested || 'copernicus';
      payload.terrainProviderForOrder = payload.terrainProviderForOrder || payload.terrainProvider || 'copernicus';

      payload.roads = {
        ...(payload.roads || {}),
        enabled: !!payload.roads?.enabled
      };
    }

    return payload;
  }

 function syncGeo3DHidden() {
  killGhostGeo3DJson();

  const input = ensureHiddenInRealProductForm();
  if (!input) return;

  const raw = getBestRawPayload();
  const payload = buildFinalPayload(raw);

  if (!payload) return;

  const extraInputs = ensureGeo3DExtraInputsInRealProductForm();

  const configId = getOrCreateGeo3DConfigId(extraInputs, payload);
  const label = buildGeo3DLabel(payload);
  const previewUrl = buildGeo3DPreviewUrl(configId);

  payload.geo3d_config_id = configId;
  payload.geo3d_label = label;
  payload.geo3d_preview_url = previewUrl;
  payload.geo3d_preview_status = payload.geo3d_preview_status || 'pending';

  input.value = JSON.stringify(payload);

    if (extraInputs) {
    extraInputs.configInput.value = configId;
    extraInputs.labelInput.value = label;
    extraInputs.previewLinkInput.value = previewUrl;
    extraInputs.previewStatusInput.value = payload.geo3d_preview_status;
    extraInputs.previewUrlInput.value = previewUrl;
  }

  seedGeo3DPreviewInBackground(payload);

  console.log('[Geo3D] payload final carrito:', {
    configId: payload.geo3d_config_id,
    label: payload.geo3d_label,
    previewUrl: payload.geo3d_preview_url,
    previewStatus: payload.geo3d_preview_status,
    mode: payload.mode,
    productType: payload.productType,
    terrainProviderRequested: payload.terrainProviderRequested,
    terrainProvider: payload.terrainProvider,
    terrainProviderFallback: payload.terrainProviderFallback,
    terrainProviderForOrder: payload.terrainProviderForOrder,
    waterMode: payload.waterMode,
    waterSource: payload.waterSource,
    waterLoweringMm: payload.waterLoweringMm,
    roadsEnabled: payload.roads?.enabled,
    buildingsEnabled: payload.buildings?.enabled,
    previewSceneEnabled: payload.previewScene?.enabled
  });

  console.log('[Geo3D] payload final carrito completo:', payload);
  console.log('[Geo3D] hidden _geo3d_json:', input.value);
}


function syncBeforeSubmitOrClick() {
  syncGeo3DHidden();

  const input = ensureHiddenInRealProductForm();

  if (input && input.value) {
    try {
      const payload = JSON.parse(input.value);
      console.log('[Geo3D] hidden FINAL justo antes de enviar:', {
        mode: payload.mode,
        productType: payload.productType,
        terrainProviderRequested: payload.terrainProviderRequested,
        terrainProviderFallback: payload.terrainProviderFallback,
        terrainProviderForOrder: payload.terrainProviderForOrder,
        waterMode: payload.waterMode,
        waterSource: payload.waterSource,
        waterLoweringMm: payload.waterLoweringMm,
        roadsEnabled: payload.roads?.enabled,
        buildingsEnabled: payload.buildings?.enabled,
        previewSceneEnabled: payload.previewScene?.enabled
      });
    } catch (e) {
      console.warn('[Geo3D] hidden FINAL inválido antes de enviar:', e);
    }
  }
}

function attach() {
  killGhostGeo3DJson();
  ensureHiddenInRealProductForm();

  window.addEventListener('geo3d:params', syncGeo3DHidden, true);

  window.addEventListener(
    'geo3d:gpx',
    function (e) {
      const d = (e && e.detail) || {};
      if (d.uid && d.uid !== UID) return;

      LAST_GPX = d.gpx ? d.gpx : null;

      window.__geo3dState = window.__geo3dState || {};
      window.__geo3dState[UID] = window.__geo3dState[UID] || { uid: UID };

      window.__geo3dState[UID].gpx = LAST_GPX;
      window.__geo3dState[UID].km = 0;

      if (d.trackColor) {
        window.__geo3dState[UID].trackColor = d.trackColor;
      }

      syncGeo3DHidden();
    },
    true
  );

  window.addEventListener(
    'geo3d:track',
    function (e) {
      const d = (e && e.detail) || {};
      if (d.uid && d.uid !== UID) return;

      window.__geo3dState = window.__geo3dState || {};
      window.__geo3dState[UID] = window.__geo3dState[UID] || { uid: UID };

      window.__geo3dState[UID].trackColor =
        d.trackColor || window.__geo3dState[UID].trackColor || null;

      syncGeo3DHidden();
    },
    true
  );

  document.addEventListener(
    'submit',
    function (e) {
      const form = e.target;

      if (!form || !form.matches || !form.matches('form[action*="/cart/add"], product-form form')) return;

      syncBeforeSubmitOrClick();
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest(
        'button[type="submit"], input[type="submit"], button[name="add"], .product-form__submit'
      );

      if (!btn) return;

      const form = btn.closest('form[action*="/cart/add"], product-form form');
      if (!form && !getRealProductForm()) return;

      syncBeforeSubmitOrClick();
    },
    true
  );

  setTimeout(syncGeo3DHidden, 300);
  setTimeout(syncGeo3DHidden, 900);
  setTimeout(syncGeo3DHidden, 1800);

  console.log('[Geo3D] ghost guard + sync + GPX fixes activos ✅');
}

  document.addEventListener('DOMContentLoaded', () => {
    killGhostGeo3DJson();
    setTimeout(killGhostGeo3DJson, 300);
    setTimeout(killGhostGeo3DJson, 1200);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
})();